/**
 * Projekte und Ziele zum Nachschlagen per ID - fuer die Verknuepfungs-Plaketten
 * in jeder Aufgabenzeile (Roadmap F-11).
 *
 * Einmal zentral geladen (`LinkNamesProvider` in der App-Huelle) statt einer
 * eigenen Datenbankabfrage pro Zeile.
 */
import { createContext, useContext } from 'react';

import type { Goal, ID, Project, Subject } from '@/domain/types';

export interface LinkNames {
  projects: Map<ID, Project>;
  goals: Map<ID, Goal>;
  /** Schulfaecher (F-22) - fuer die Fach-Plakette an Hausaufgaben. */
  subjects: Map<ID, Subject>;
}

export const LinkNamesContext = createContext<LinkNames>({
  projects: new Map(),
  goals: new Map(),
  subjects: new Map(),
});

export function useLinkNames(): LinkNames {
  return useContext(LinkNamesContext);
}
